import type { NDateLocale } from './enUS'
import { ms } from 'date-fns/locale'

const dateMsMY: NDateLocale = {
  name: 'ms-MY',
  locale: ms
}

export default dateMsMY
